import { render } from "./HomepageMenuGroup.vue?vue&type=template&id=17fc0f6a"
import script from "./HomepageMenuGroup.vue?vue&type=script&lang=js"
export * from "./HomepageMenuGroup.vue?vue&type=script&lang=js"

import "./HomepageMenuGroup.vue?vue&type=style&index=0&id=17fc0f6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
